import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * ChangeGrid class.
 */
export default class ChangeGrid extends withBreakpointObserver(Base) {
  static config = {
    name: 'ChangeGrid',
    refs: ['btnChange', 'btnReset'],
  };

  /**
   * Reset grid !
   * @param {object} props Props
   * @param {object} props.target Current element.
   */
  onBtnResetClick({ target }) {
    target.classList.remove('opacity-50');
    this.$refs.btnChange.classList.add('opacity-50');
    this.$parent.$parent.$refs.container.classList.remove('!grid-cols-1');
    this.$parent.$update();
  }

  /**
   * Switch to one column grid !
   * @param {object} props Props
   * @param {object} props.target Current element.
   */
  onBtnChangeClick({ target }) {
    target.classList.remove('opacity-50');
    this.$refs.btnReset.classList.add('opacity-50');
    this.$parent.$parent.$refs.container.classList.add('!grid-cols-1');
    this.$parent.$update();
  }
}
